export const BOARDLESS_LOCATION_NAME = 'Other locations';
